/* Meet Nomsa · Multiple financial relationships.
 * Uses the pre-cropped Meet-Nomsa scene as a still. A bold headline
 * "MULTIPLE FINANCIAL RELATIONSHIPS." fades in near the end,
 * positioned to sit across Nomsa's mouth so the misplaced smile is hidden.
 */
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";

const BG = "/prologue/nomsa_meet_bg.png";
const GOLD = "#C9A24A";

export default function NomsaMeetDemo() {
  const [params] = useSearchParams();
  const embed = params.get("embed") === "1";

  const scene = (
    <div className="relative w-full h-full overflow-hidden" data-testid="nomsa-meet"
      style={{ background: "#050914" }}>
      {/* Still · pre-cropped Meet Nomsa scene */}
      <img
        src={BG}
        alt=""
        className="absolute inset-0 w-full h-full"
        style={{ objectFit: "cover" }}
      />

      {/* Bold headline — sits across Nomsa's mouth to mask the misplaced smile */}
      <div
        className="absolute"
        style={{
          left: "50%",
          top: "58%",
          transform: "translate(-50%, -50%)",
          width: "88%",
          textAlign: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.7, delay: 3.0, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Dark backing plate so the text always reads over any face detail beneath */}
          <div
            className="inline-block px-10 py-6 rounded-2xl"
            style={{
              background: "linear-gradient(180deg, rgba(8,12,20,0.94), rgba(5,9,20,0.94))",
              border: `2px solid ${GOLD}`,
              boxShadow: "0 20px 80px rgba(0,0,0,0.85), 0 0 60px rgba(201,162,74,0.35)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
            }}
          >
            <div
              className="font-extrabold uppercase text-white"
              style={{
                fontSize: 62,
                lineHeight: 1.02,
                letterSpacing: 1.5,
                textShadow: "0 4px 24px rgba(0,0,0,0.9)",
              }}
            >
              MULTIPLE FINANCIAL<br />RELATIONSHIPS.
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );

  if (embed) {
    return (
      <div className="w-screen h-screen" style={{ background: "#050914" }}>
        {scene}
      </div>
    );
  }
  return (
    <div className="w-full" style={{ background: "#050914", minHeight: "100vh" }}>
      <div className="mx-auto" style={{ maxWidth: 1600, aspectRatio: "16/9" }}>{scene}</div>
    </div>
  );
}
